module.exports = __webpack_public_path__ + "img/applyChange.602767d1.svg";